import { render, staticRenderFns } from "./StationPage.vue?vue&type=template&id=48d84f54"
import script from "./StationPage.vue?vue&type=script&lang=js"
export * from "./StationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports